/* ------------------------------------------------------------------ */
/*  Hard-coded walk-in drives. Add new objects to this array to list   */
/*  more drives — the list page and each drive's detail page both read */
/*  from here. The `id` field doubles as the URL slug                  */
/*  (e.g. /walkin-drives/bigbasket-customer-support-ameerpet).         */
/* ------------------------------------------------------------------ */
export const WALKIN_DRIVES = [
  {
    id: "techm-service-desk-intl-voice",
    title:
      "Mega Walk-in Drive — Service Desk Technical Support (International Voice)",
    company: "Tech Mahindra Ltd",
    venue: "Bahadurpally, Hyderabad",
    mapUrl: "https://share.google/PByYisXQUdq4mwBUW",
    contactPerson: "Aniketh",
    salary: "₹3 – 5.5 LPA",
    timeAndVenue: {
      dates: "22nd June – 10th July",
      time: "11:00 AM – 12:30 PM",
      place: "Tech Mahindra, Bahadurpally",
    },
    overview: [
      "Hiring for — Service Desk (Technical Support || International Voice)",
      "We are looking for enthusiastic candidates to join our Technical Support International Voice (Service Desk) team. The role involves handling customer queries, providing timely solutions, and maintaining excellent service quality.",
    ],
    meta: {
      role: "Technical Support – Voice / Blended",
      industry: "IT Services & Consulting",
      department: "Customer Success, Service & Operations",
      roleCategory: "Voice / Blended",
      employmentType: "Full Time, Permanent",
      education: "Graduation Not Required",
      experience: "0 – 5 Years / Freshers",
    },
    rolesOpen: [
      "Technical Support Associate",
      "Senior Technical Support Associate",
    ],
    responsibilities: [
      {
        title: "Technical Support (L1 / L2)",
        items: [
          "Respond to customer queries via calls / emails.",
          "Troubleshoot and resolve technical issues.",
          "Maintain proper documentation of incidents.",
          "Ensure customer satisfaction with prompt service.",
        ],
      },
      {
        title: "Service Desk Operations",
        items: [
          "ITSM Tools (ServiceNow, BMC Remedy, HPSM, CA Service Desk)",
          "Active Directory (User Management, Password Reset, Account Unlock)",
          "Microsoft Office & O365 Support (Outlook, Excel, Teams)",
          "Windows OS (7 / 8 / 10) & Desktop Troubleshooting",
          "VPN / Citrix / Exchange Support",
          "Hardware & Network Troubleshooting (LAN, Printers, Devices)",
          "Remote Troubleshooting (Desktop, Laptop, Mobile, Printers)",
          "Antivirus, Patch Management, SCCM basics",
          "Voice (Excellent Communication Skills) & knowledge of ITIL processes",
        ],
      },
    ],
    requirements: [
      "Freshers (NOT pursuing any course)",
      "0–5 years experience in technical support — International Voice only",
      "Excellent communication skills in English",
      "Willingness to work in rotational / night shifts (24/7)",
      "Work from office",
      "Work location — Bahadurpally, Hyderabad",
      "Immediate joiners preferred",
      "Basic knowledge of technical issues",
    ],
    perks: [
      "Training and career growth opportunities",
      "Friendly work environment",
    ],
    walkInDetails:
      'Candidates should carry their Resume and Aadhaar card. Please mention "Aniketh" on top of your resume while coming.',
    importantNote:
      "Please do not walk in on festive dates, Saturdays & Sundays.",
    keySkills: [
      "Service Desk",
      "International Voice Process",
      "US Calling",
      "Technical Voice Process",
      "International Voice",
      "US Voice Process",
      "International BPO",
      "International Calling",
    ],
    about:
      "Tech Mahindra Ltd — Registered Office: Sharda Centre, Off Karve Road, Erandwana, Pune, Maharashtra, India.",
  },
  {
    id: "techm-intl-voice-ecom-blr",
    title: "Mega Walk-in Drive For International Voice Process (Mon- Fri)",
    company: "Tech Mahindra",
    venue: "Electronic City Phase II, Bengaluru",
    naukriUrl:
      "https://www.naukri.com/job-listings-walk-in-mega-walkin-drive-for-international-voice-process-mon-fri-tech-mahindra-bengaluru-0-to-5-years-230626020820",
    contactPerson: "Nelson / Krithika",
    salary: "₹3 – 4.75 LPA",
    timeAndVenue: {
      dates: "24th June – 14th July 2026",
      time: "10:30 AM – 5:30 PM",
      place:
        "Tech Mahindra, Phase II, Electronic City, Doddanagamangala Village, Bengaluru 560100",
    },
    overview: [
      "Tech Mahindra is conducting a Mega Walk-in Drive for International Voice Process (E-commerce Voice Support). We are looking for candidates with excellent communication skills and a customer-focused approach.",
    ],
    meta: {
      role: "Non Tech Support – Voice / Blended",
      industry: "BPM / BPO",
      department: "Customer Success, Service & Operations",
      roleCategory: "Voice / Blended",
      employmentType: "Full Time, Permanent",
      education: "Graduation Not Required",
      experience: "0 – 5 Years / Freshers",
    },
    rolesOpen: [
      "International Voice Process Associate",
      "E-commerce Voice Support Associate",
    ],
    responsibilities: [
      {
        title: "Key Responsibilities",
        items: [
          "Handle international customer queries via calls.",
          "Provide support for E-commerce-related issues.",
          "Deliver timely and effective resolutions.",
          "Maintain high customer satisfaction levels.",
        ],
      },
    ],
    requirements: [
      "Graduates and Undergraduates can apply",
      "Freshers & experienced candidates are welcome",
      "Excellent English communication skills",
      "Basic computer knowledge",
      "Typing speed: Minimum 20 WPM with 80% accuracy",
      "Open to working night shifts",
    ],
    perks: [
      "Experience in international voice process (preferred)",
      "Good listening and problem-solving skills",
    ],
    walkInDetails: "Candidates can walk in directly with an updated resume.",
    importantNote:
      "Walk-in is open Monday to Friday only. Please carry an updated resume.",
    keySkills: [
      "International Call Center",
      "International Voice",
      "International Process",
      "International Voice Process",
      "International Calling",
    ],
    about:
      "Tech Mahindra Business Services is a subsidiary of Tech Mahindra, part of the Mahindra Group. Tech Mahindra is a USD 4.9 billion company with 131,500+ professionals across 90 countries, serving 946 global customers including Fortune 500 companies. Its BPO arm, Tech Mahindra Business Process Services, provides Next Gen Digital Customer Experience & Back Office services across industries. Address: Sharda Centre, Off Karve Road, Erandwana, Pune, Maharashtra, India.",
  },
  {
    id: "bigbasket-customer-support-ameerpet",
    title: "Bigbasket Walk-in || Customer Support Associate",
    company: "Bigbasket",
    venue: "Ameerpet, Hyderabad",
    mapUrl: "https://maps.app.goo.gl/VJYbKuHHe1RA3A6x5",
    contactPerson: "Meghana (9511921087)",
    salary: "₹2 – 2.5 LPA",
    timeAndVenue: {
      dates: "24th June – 8th July 2026",
      time: "11:00 AM – 4:00 PM",
      place:
        "Big Basket IRCPL, 7-1-618/ATC/506, 507, 508, 5th Floor, Aditya Trade Centre, Ameerpet, Hyderabad, Telangana – 500016",
    },
    overview: [
      "We are looking for talented Customer Service Executive professionals to join our team in Ameerpet, Hyderabad.",
      "Hybrid model — first 3 months Work From Office (training), then Work From Home (every 2 months, 6 days WFO if required).",
      "The job requires interacting with customers over calls to ensure all issues are resolved to the customer's satisfaction. You will understand the customer's problem accurately, follow established procedures to resolve it, and communicate clearly. As a Customer Service Executive you will deal with our customers from all over India.",
    ],
    meta: {
      role: "Voice / Blended – Other",
      industry: "Retail",
      department: "Customer Success, Service & Operations",
      roleCategory: "Voice / Blended",
      employmentType: "Full Time, Permanent",
      education: "Graduation Not Required",
      experience: "0 – 4 Years / Freshers",
    },
    rolesOpen: ["Customer Support Associate", "Customer Service Executive"],
    responsibilities: [
      {
        title: "Key Responsibilities",
        items: [
          "Handle customer calls to resolve issues and ensure customer satisfaction.",
          "Understand the customer's problem accurately and follow established procedures.",
          "Communicate clearly with customers across India.",
          "Maintain high quality standards in every interaction.",
        ],
      },
    ],
    requirements: [
      "Fluent in English, Hindi & Telugu (or) English, Hindi & Marathi (or) English, Hindi & Bengali",
      "Typing speed: Minimum 20–25 WPM",
      "Education: Any (10+2, Diploma, Degree) — strictly NO to B.Tech, MBA and PG freshers",
      "Freshers and candidates with BPO experience can apply",
      "Must be a team player with a committed, positive attitude",
      "Flexible for rotational shifts between 06:00 AM – 11:45 PM (any 9 hours)",
      "Age limit: 30 years",
    ],
    perks: ["PF, ESIC and Internet allowance"],
    walkInDetails:
      "Walk in every Monday to Saturday from 11:00 AM to 4:00 PM at the venue. Steps to reach: Ameerpet Metro Station → Aditya Trade Centre → enter from Aditya Park Hotel → 5th Floor → 506, 507 & 508 → BigBasket Customer Support. Message 'Hi' on WhatsApp +91-9511921087 (calls will not be answered).",
    importantNote:
      "Interviews are held Monday to Saturday only (10:00 AM – 4:00 PM). Calls will not be answered — reach out on WhatsApp only.",
    keySkills: ["English", "Telugu", "Typing Skills", "Hindi"],
    about:
      "BIG BASKET (Innovative Retail Concepts Private Limited) is India's largest online food and grocery store, with over 25,000 products and 1,000+ brands. E-grocery is one of the fastest-growing segments in consumer e-commerce, propelled by India's rising consumption and digital penetration. Bigbasket lets customers shop for all their food and grocery needs from the comfort of home or office, delivered right to their doorstep. Company Address: 1st Floor, Innovative Retail Concepts Private Limited, Survey No. 186 & 187, Opp ZPHS Kondapur, Botanical Garden Road, Masjid Banda, Kondapur, Hyderabad – 500084.",
  },
];

/** Look up a single drive by its slug (the `id` field). */
export const getDriveBySlug = (slug) =>
  WALKIN_DRIVES.find((drive) => drive.id === slug);
